import cn from "@/lib/cn";

const VisaSvgPaths = () => (
  <>
    <path
      d="m13.392,12.624l-2.838,6.77h-1.851l-1.397-5.403c-.085-.332-.158-.454-.416-.595-.421-.229-1.117-.443-1.728-.576l.041-.196h2.98c.38,0,.721.253.808.69l.738,3.918,1.822-4.608h1.84Z"
      fill="#fff"
      strokeWidth="0"
    />
    <path
      d="m20.646,17.183c.008-1.787-2.47-1.886-2.453-2.684.005-.243.237-.501.743-.567.251-.032.943-.058,1.727.303l.307-1.436c-.421-.152-.964-.299-1.638-.299-1.732,0-2.95.92-2.959,2.238-.011.975.87,1.518,1.533,1.843.683.332.912.545.909.841-.005.454-.545.655-1.047.663-.881.014-1.392-.238-1.799-.428l-.318,1.484c.41.188,1.165.351,1.947.359,1.841,0,3.044-.909,3.05-2.317"
      fill="#fff"
      strokeWidth="0"
    />
    <path
      d="m25.423,12.624h-1.494c-.337,0-.62.195-.746.496l-2.628,6.274h1.839l.365-1.011h2.247l.212,1.011h1.62l-1.415-6.77Zm-2.16,4.372l.922-2.542.53,2.542h-1.452Z"
      fill="#fff"
      strokeWidth="0"
    />
    <path
      fill="#fff"
      strokeWidth="0"
      d="M15.894 12.624L14.446 19.394 12.695 19.394 14.143 12.624 15.894 12.624z"
    />
  </>
);

interface CardBrandLogoProps {
  brand: string;
  size?: "sm" | "md";
}

export function CardBrandLogo({ brand, size = "md" }: CardBrandLogoProps) {
  const isVisa = brand.toUpperCase() === "VISA";
  const dimensions =
    size === "sm"
      ? { container: "h-7 w-10", svgSize: 32 }
      : { container: "h-[30px] w-11", svgSize: 34 };

  return (
    <div
      className={cn(
        "flex shrink-0 items-center justify-center overflow-hidden rounded-md",
        dimensions.container,
        isVisa ? "bg-[#1A1F71]" : "bg-[#F3F4F6]",
      )}
    >
      {isVisa ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={dimensions.svgSize}
          height={Math.round(dimensions.svgSize * 0.625)}
          viewBox="0 0 32 32"
        >
          <VisaSvgPaths />
        </svg>
      ) : (
        <div className="flex items-center">
          <div
            className={cn(
              "rounded-full bg-[#EB001B] opacity-90",
              size === "sm" ? "size-4" : "size-[18px]",
            )}
          />
          <div
            className={cn(
              "rounded-full bg-[#F79E1B] opacity-90",
              size === "sm" ? "-ml-1.5 size-4" : "-ml-[7px] size-[18px]",
            )}
          />
        </div>
      )}
    </div>
  );
}
